export default function IosNutritionOutline() {
  return (
    <div
      className="ion-icon-ios-nutrition-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M358,233.855l0.413-0.039c-0.137-0.137-0.046-0.101-0.185-0.237L279.798,155h-0.004c-5.833-6-14.193-10.154-23.485-10.154
		c-11.811,0-22.115,6.154-27.635,16.154h-0.007c0,0-7.09,10.994-18.27,28.874l32.531,39.637c2.939,3.769,3.296,7.801,1.411,9.689
		l-0.114,0.071c-0.909,0.909-2.021,1.33-3.274,1.33c-1.908,0-4.142-0.99-6.485-2.768l-35.872-29.418
		c-23.546,37.655-56.677,90.634-83.45,133.451l19.072,23.337c2.939,3.77,3.296,7.884,1.41,9.772l-0.114,0.114
		c-0.911,0.913-2.028,1.342-3.287,1.342c-1.905,0-4.136-0.981-6.472-2.755l-21.067-16.533C84.734,389.051,70,412.464,68,414.366
		v0.003c-3,5.062-4.085,11.132-4.085,17.664c0,17.655,14.657,31.967,32.285,31.967c7.821,0,14.57-3.395,20.799-7.5l114.651-84.109
		l-28.838-35.358c-2.94-3.769-3.268-7.887-1.382-9.775l0.128-0.114c0.912-0.912,2.034-1.341,3.294-1.341
		c1.905,0,4.14,0.981,6.476,2.755l37.864,31.59C304.03,319.902,355.082,283,355.082,283h0.005c7.839-6,12.473-15.711,12.473-26.238
		c0-8.704-3.56-17.14-9.56-22.904V233.855z M345.531,269.834c-2.664,1.934-46.692,33.932-95.764,69.899l-28.272-23.483l-0.26-0.223
		l-0.274-0.211c-5.245-3.981-10.663-5.998-16.108-5.998c-5.465,0-10.592,2.097-14.458,5.909l-0.064,0.062l-0.083,0.082l-0.083,0.083
		c-7.808,7.821-7.761,20.823,0.111,30.917l0.11,0.143l0.113,0.138l18.223,22.312l-100.656,73.896
		c-5.066,3.304-8.427,4.657-11.542,4.657c-8.822,0-16-7.171-16-15.983c0-3.086,0.694-6.045,2.017-8.623
		c2.391-3.161,6.6-9.876,18.655-29.351c2.543-4.108,5.252-8.487,8.134-13.129l6.39,5.176l0.195,0.156l0.2,0.152
		c5.245,3.981,10.665,6,16.111,6c5.517,0,10.692-2.139,14.571-6.023l0.114-0.113c7.806-7.817,7.756-20.82-0.118-30.916l-0.113-0.144
		l-0.115-0.142l-11.814-14.455l43.693-69.872l24.059-38.474l21.855,17.922l0.231,0.19l0.24,0.181
		c5.254,3.988,10.678,6.01,16.123,6.01c4.954,0,9.631-1.725,13.339-4.89l0.461-0.337l0.871-0.874
		c7.79-7.803,7.74-20.778-0.118-30.854l-0.12-0.153l-0.124-0.15l-25.239-30.539c2.957-4.703,5.457-8.491,7.405-11.488l5.209-8.494
		c2.777-5.025,7.761-8.157,13.673-8.157c4.367,0,8.76,2.042,12.057,5.43l4.701,4.928h0.122L342,240.286v0.376l5.186,4.716
		c2.793,2.69,4.539,6.782,4.539,11.227C351.725,261.801,349.467,266.728,345.531,269.834z"/>
	<polygon points="439.994,115.175 435.216,117.938 343.578,170.93 407.313,60.358 409.83,55.992 396.011,48 393.523,52.313 
		322.748,175.098 339.418,191.794 443.38,131.674 447.974,129.018 	"/>
</g>
</svg>
`,
      }}
    />
  )
}
